module.exports = __webpack_public_path__ + "e7448a9cdb6c6ef5f91ac5e25f45315e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-basic-4.png
// module id = 2769
// module chunks = 0